const HeroCarousel = () => {
  return null;
};

export default HeroCarousel;
